import {
  DateCalendar,
  LocalizationProvider,
  PickersDay,
} from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DateTime } from "luxon";
import { PickersDayProps } from "@mui/lab";

export const CustomDatePicker = ({
  date,
  setDate,
  isMobile
}) => {

  const handleDateChange = (newDate) => {
      setDate(newDate);
  };

  const renderDay = (
    props: PickersDayProps<any> & {
      selectedDay?: DateTime | null;
    }
  ) => {
    const { day, selectedDay, ...other } = props;
    const isSelected = date && props.day.hasSame(date, "day");

    return (
      <PickersDay
        {...other}
        day={props.day}
        sx={[ isMobile && {fontSize: 10, height: 30, width: 30},{
          bgcolor:
            isSelected
              ? "primary.main"
              : "inherit",
          color: isSelected ? "white" : "inherit",
        }]}
      />
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="gb-en">
      <DateCalendar
        sx={[isMobile && {width: 300}]}
        disableFuture
        showDaysOutsideCurrentMonth
        displayWeekNumber
        value={date}
        onChange={handleDateChange}
        slots={{ day: renderDay }}
        slotProps={{
          day: (ownerState) =>
            ({
              selectedDay: date,
            } as any),
        }}
      />
    </LocalizationProvider>
  );
};
